import { useQuery } from "@tanstack/react-query";
import api from "../../api/apiClient";

export interface ContactInfo {
  landingPagePhoneNumber: string;
  customerAppPhoneNumber: string;
  storePhoneNumber: string;
  email: string;
  country: string;
}

export const useContactInfoByAdmin = () => {
  return useQuery({
    queryKey: ["contact-info-by-admin"],
    queryFn: () =>
      api
        .get<ContactInfo>("system-setting")
        .then((res) => res.data),
  });
};